var exports = {
  "z": "OperatorPassPassItOnModal.module__root___aFBWX1",
};

module.exports = exports;
